module.exports = __webpack_public_path__ + "img/fig30.03708fd1.jpg";